import PropTypes from 'prop-types'

import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} TpmsMeasurement
 * @property {number} pressure
 * @property {ISO8601} time
 */
export const tpmsMeasurementPropType = PropTypes.shape({
    pressure: PropTypes.number,
    time: iso8601PropType
})
